import {Link, LinkProps} from 'react-router-dom';
import clsx from 'clsx';
import React, {useMemo} from 'react';
import {Artist} from '@app/web-player/artists/artist';
import {slugifyString} from '@ui/utils/string/slugify-string';
import {UserArtist} from '@app/web-player/user-profile/user-artist';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import { isIOSOrAndroid } from '@common/core/platform-detection';
import { StackTrigger } from '@ui/overlays/stack-navigator/stack-trigger';
import { ArtistPage } from './artist-page/artist-page';

interface AlbumLinkProps extends Omit<LinkProps, 'to'> {
  artist: Artist | UserArtist;
  className?: string;
  openInDialogTrigger?: boolean;
  closePlayerOverlayOnOpen?: boolean;
}
export function ArtistLink({
  artist,
  className,
  openInDialogTrigger = true,
  closePlayerOverlayOnOpen = false,
  ...linkProps
}: AlbumLinkProps) {
  const hasValidArtistId =
    typeof artist?.id === 'number' && Number.isFinite(artist.id) && artist.id > 0;
  const finalUri = useMemo(() => {
    return getArtistLink(artist);
  }, [artist]);

  if (!hasValidArtistId) {
    return (
      <span
        className={clsx(
          'truncate outline-none',
          className,
        )}
      >
        {artist.name}
      </span>
    );
  }
  
  return (
    <>
    {!isIOSOrAndroid() || !openInDialogTrigger ? (
      <Link
        {...linkProps}
        className={clsx(
          'truncate outline-none hover:underline focus-visible:underline',
          className,
        )}
        to={finalUri}
      >
        {artist.name}
      </Link>
    ) : (
      <StackTrigger
        moveFocusToDialog={false}
        title={artist.name}
        closePlayerOverlayOnOpen={closePlayerOverlayOnOpen}
      >
        <span className={clsx(
          'truncate outline-none hover:underline focus-visible:underline',
          className,
        )}>{artist.name}</span>
        <ArtistPage artist={artist} />
      </StackTrigger>
    )}
  </>
  );
}

export function getArtistLink(
  artist: Artist | UserArtist,
  {absolute}: {absolute?: boolean} = {},
): string {
  let link = `/artist/${artist.id}/${slugifyString(artist.name)}`;
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
